import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { colors, layout } from 'Constants';

import {
  Container,
  Header,
  Icon,
  Anchor,
  Button,
  Footnote,
  TableHead
} from 'Components/core';
import { replaceAnchor } from 'Root/libs/anchor';

import InfoBox from 'Components/InfoBox';
import ReadyToEnroll from 'Views/benefits/components/ReadyToEnroll';
import { compact } from 'libs/array';

// State
import { ApiStore, getFindADoctorSites, Subscribe } from 'Store';

// Check Box List
import CheckBoxList from './components/CheckBoxList';
import CheckBoxListItem from './components/CheckBoxListItem';

// Table
import Table from 'Components/Table';

// Card
import CardContainer from 'Components/Card/CardContainer';
import CardHighlighted from 'Components/Card/CardHighlighted';
import Card from 'Components/Card';

// Tabs
import Tab from 'Components/Tab';

// Icons
import { faMedkit, faBell } from '@fortawesome/free-solid-svg-icons';

// Images
import medicalBenefits from './images/medical_tab_image@2x.png';
import findDoctor from './images/Explore_Your_Benefits_-_Find_Care.jpeg';






function generateTabs(state, activeTab, setActiveTab) {
  const medicalPlans = state.medical?.medicalBenefits?.planMedical;
  if (!Array.isArray(medicalPlans)) return [];
  let tabs = state.medical.medicalBenefits.planMedical.map(
    ({ type, name }, index) => {
      if (!(name || type)) {
        return null;
      }

      return (
        <Tab
          key={type}
          onClick={() => setActiveTab(index)}
          active={activeTab === index}
          header={name || type}
        />
      );
    }
  );
  console.log('Tab', tabs);
  tabs = compact(tabs);
  return tabs;
}

import tabContent from './tab-content';
import CODES from 'Root/libs/analytics/CodeDef';
import Api from 'Root/libs/analytics/Api';
import { HeaderV2, SubHeader, TitleHeader } from 'Components/core/Header';

function toArray(val) {
  return Array.isArray(val) ? val : [val];
}

const getTabContent = (state, activeTab) => {
  const medicalPlan = state.medical?.medicalBenefits?.planMedical[activeTab];

  if (!medicalPlan) {
    return null;
  }
  /**
   * handle old data
   */
  if (
    !medicalPlan.summary &&
    !medicalPlan.highlights?.bullet &&
    !medicalPlan.footNotes?.footNote &&
    !medicalPlan.basicsVideoURL
  ) {
    return (
      <Container column seperation="16px">
        {tabContent[medicalPlan.type]}
        {planTexts}
      </Container>
    );
  }

  const bullets = toArray(
    medicalPlan.highlights?.bullet ? medicalPlan.highlights?.bullet : []
  );
  const bulletText =
    typeof medicalPlan.highlights === 'string' ? medicalPlan.highlights : false;
  const footNotes = toArray(medicalPlan.footNotes?.footNote);
  const planTexts = [
    <p dangerouslySetInnerHTML={{ __html: medicalPlan.summary }}></p>,
    <React.Fragment>
      {bulletText && (
        <p dangerouslySetInnerHTML={{ __html: replaceAnchor(bulletText) }}></p>
      )}
      {bullets && (
        <ul>
          {bullets.map(singleBullet => {
            return (
              <li
                key={singleBullet}
                dangerouslySetInnerHTML={{ __html: singleBullet }}
              ></li>
            );
          })}
        </ul>
      )}
    </React.Fragment>,
    ,
    <div>
      {medicalPlan.basicsVideoURL && (
        <Anchor code={CODES.MED_BFT_VIDEO} to={medicalPlan.basicsVideoURL}>
          {medicalPlan.basicsVideoLabel
            ? medicalPlan.basicsVideoLabel
            : 'Watch our HMO Basics Video to learn more'}
        </Anchor>
      )}
    </div>,
    <React.Fragment>
      {footNotes && (
        <Footnote>
          {footNotes.map(footnote => {
            if (!footnote) {
              return '';
            }
            footnote = footnote.replace(
              /<a/gi,
              '<a class="external" target="blank"'
            );
            return <div dangerouslySetInnerHTML={{ __html: footnote }}></div>;
          })}
        </Footnote>
      )}
    </React.Fragment>
  ];

  return (
    <Container column seperation="16px">
      {planTexts}
    </Container>
  );
};

export default () => {
  useEffect(() => {
    Api.recordAcitity(CODES.MENU_MEDICAL_BENIFITS);
  }, []);

  let [activeTab, setActiveTab] = useState(0);

  return (
    <Subscribe to={[ApiStore]}>
      {state => {
        const tabs = generateTabs(state, activeTab, setActiveTab);

        return (
          <Container
            seperation="24px"
            column
            maxWidth
            style={{ margin: 'auto'}}
          >
            <HeaderV2
              title={'Explore Your Benefits'}
              text={
                <>
                  {' '}
                  {state.brandInfo.name} and your
                  {state.employer ||
                    ' employer' /* TODO: Get the employer data */}{' '}
                  want to make connecting to your best health easier than ever.
                  Take time to discover the right plan for you.
                </>
              }
            ></HeaderV2>

        
            {Array.isArray(state.medical?.medicalPlansBullets) && [
              <p>All {state.brandInfo.name} plans include:</p>,
              <CheckBoxList>
                {state.medical.medicalPlansBullets.map(val => (
                  <CheckBoxListItem>{val}</CheckBoxListItem>
                ))}
              </CheckBoxList>
            ]}
            {state.medical?.medicalPlansChart &&
              !Array.isArray(state.medical?.medicalPlansChart) && (
                <Container column style={{marginBottom:40}} >
                  <TableHead>
                    Compare the plans
                  </TableHead>
                  <Table
                    headers={state.medical?.medicalPlansChart.headers}
                    sets={state.medical?.medicalPlansChart.sets}
                    gotDocType={state.medical?.medicalPlansChart.gotDocType}
                  />
                  <Footnote>
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          state.medical?.medicalPlansChart?.planChartFootnotes
                      }}
                    ></div>
                  </Footnote>
                </Container>
              )}
            {tabs.length > 0 && (
              <InfoBox image={medicalBenefits} header="Medical Benefits">
                <Container
                  seperation="0px"
                  style={{ width: '100%', marginBottom: '16px' ,overflowX:'auto' }}
                >
                  {tabs}
                </Container>
                {getTabContent(state, activeTab)}
              </InfoBox>
            )}
            {false && <InfoBox image={findDoctor} header="Find Care">
              <Container column seperation="16px">
                <p style={{ textAlign: 'center' }}>
                  The right doctor can make all the difference and choosing one
                  in your plan can save you money, too.
                </p>
                <Header style={{ textAlign: 'center' }}>
                  Find care near you
                </Header>
                <CardContainer>
                  <Card column>
                    <Icon icon={faMedkit} size="2x" />
                    <p>
                      <b>Want to see if your doctor is in the plan?</b>
                    </p>

                    {state.medical?.deepLink && (
                      <p style={{ textAlign: 'left' }}>
                        {toArray(state.medical?.deepLink?.link).map(link => (
                          <>
                            <Anchor
                              code={CODES.EXT_CLICK}
                              to={link.url}
                              key={link.url}
                            >
                              {link.label}
                            </Anchor>
                            <br />
                          </>
                        ))}
                      </p>
                    )}
                    <Anchor
                      code={CODES.MED_BFT_SEARCH_NETWORK}
                      to={state.doctorURL.link}
                      style={{ alignSelf: 'center' }}
                    >
                      Search the {state.doctorURL.name} network.
                    </Anchor>
                  </Card>
                  <Card column>
                    <Icon icon={faBell} size="2x" />
                    <p>
                      <b>Looking for a new doctor?</b>
                    </p>
                    <p>
                      Once you’re a member, it’s easy to find care in your plan.
                      Simply use the <b>{state.mobileAppInfo?.appName}</b>{' '}
                      mobile app or use the{' '}
                      <Anchor
                        code={CODES.MED_BFT_FIND_DOC}
                        to={state.doctorURL.link}
                      >
                        Find Care tool
                      </Anchor>{' '}
                      at {state.doctorURL.website} to search for doctors,
                      hospitals, labs and other health care professionals.
                    </p>
                  </Card>
                </CardContainer>
                {state.oeMaterials?.oeBrochure?.oeBrochureURL &&
                  (state?.oeMaterials?.oeBrochure?.oeBrochureURL + '').length >
                    0 && (
                    <CardHighlighted>
                      <Header>Open Enrollment Booklet</Header>
                      <Anchor
                        code={CODES.MED_BFT_EN_BOOK}
                        to={state.oeMaterials?.oeBrochure?.oeBrochureURL}
                        style={{ alignSelf: 'center' }}
                      >
                        View or download
                      </Anchor>
                    </CardHighlighted>
                  )}
              </Container>
            </InfoBox>}
           {false &&  <ReadyToEnroll />}
          </Container>
        );
      }}
    </Subscribe>
  );
};
